import { trpc } from '@/lib/trpc';
import { useCurrentUser } from '@/hooks/use-current-user-org';

const POLL_FAST = 10_000;
const POLL_SLOW = 30_000;

export function useActiveChats() {
  const { isAuthenticated, isLoading: isAuthLoading } = useCurrentUser();

  const query = trpc.chat.getActiveChats.useQuery(undefined, {
    enabled: isAuthenticated && !isAuthLoading,
    refetchOnWindowFocus: true,
    refetchInterval: ({ state }) => ((state.data?.running.length ?? 0) > 0 ? POLL_FAST : POLL_SLOW),
  });

  const running = query.data?.running ?? [];
  const recentlyCompleted = query.data?.recentlyCompleted ?? [];

  return { running, recentlyCompleted, ...query };
}
